module.exports = __webpack_public_path__ + "static/img/aguardando.be1d0c1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aguardando.gif
// module id = qkh1
// module chunks = 1